import { useEffect } from "react";
import supabase, { supabaseAnonKey, supabaseUrl } from "@/supabase";
import { createApi } from "./api";
import { ApiProviderContext } from "./ApiProviderContext";

const api = createApi({
  baseUrl: `${supabaseUrl}/functions/v1`,
  anonKey: supabaseAnonKey,
  loadAuthToken: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    return session?.access_token ?? null;
  },
  // getSession keeps handing out the stored token until the local clock says it is
  // near expiry; refreshSession asks for a new one whatever the local clock believes.
  refreshAuthToken: async () => {
    const {
      data: { session },
    } = await supabase.auth.refreshSession();
    // Supabase reports a missing session as an error plus an empty session, not a throw.
    return session?.access_token ?? null;
  },
});

export function ApiProvider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      api.setAuthToken(session?.access_token ?? supabaseAnonKey);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      api.setAuthToken(session?.access_token ?? supabaseAnonKey);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <ApiProviderContext.Provider
      value={{
        api,
        supabase,
      }}
    >
      {children}
    </ApiProviderContext.Provider>
  );
}
